import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { isJSONAttribute, toJSONAttribute } from 'cio/utils/attributes';

export default class AuditLogModel extends Model {
  @attr('number') timestamp!: number;
  @attr('number') userId!: number;
  @attr('string') userEmail!: string;
  @attr('string') ipAddr!: string;
  @attr('string') objectType!: string;
  @attr('string') objectId!: string;
  @attr('number') version!: number;
  @attr('string') action!: string;
  @attr('string') data!: string;

  get isDataJSON() {
    return isJSONAttribute(this.data);
  }

  get jsonData() {
    if (!this.isDataJSON) {
      return null;
    }

    try {
      return toJSONAttribute(this.data);
    } catch {
      return null;
    }
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'audit-log': AuditLogModel;
  }
}
